import { combineReducers } from 'redux';
import { push } from 'react-router-redux';
import { authService } from 'services';

export const TOGGLE_LOGIN_MODE = 'user/TOGGLE_LOGIN_MODE';
export const MANUAL_LOGIN_USER = 'user/MANUAL_LOGIN_USER';
export const LOGIN_SUCCESS_USER = 'user/LOGIN_SUCCESS_USER';
export const LOGIN_ERROR_USER = 'user/LOGIN_ERROR_USER';
export const SIGNUP_USER = 'user/SIGNUP_USER';
export const SIGNUP_SUCCESS_USER = 'user/SIGNUP_SUCCESS_USER';
export const SIGNUP_ERROR_USER = 'user/SIGNUP_ERROR_USER';
export const LOGOUT_USER = 'user/LOGOUT_USER';
export const LOGOUT_SUCCESS_USER = 'user/LOGOUT_SUCCESS_USER';
export const LOGOUT_ERROR_USER = 'user/LOGOUT_ERROR_USER';


function beginLogin() {
  return { type: MANUAL_LOGIN_USER };
}

function loginSuccess(message) {
  return {
    type: LOGIN_SUCCESS_USER,
    message
  };
}

function loginError(message) {
  return {
    type: LOGIN_ERROR_USER,
    message
  };
}

function signUpError(message) {
  return {
    type: SIGNUP_ERROR_USER,
    message
  };
}

function beginSignUp() {
  return { type: SIGNUP_USER };
}

function signUpSuccess(message) {
  return {
    type: SIGNUP_SUCCESS_USER,
    message
  };
}

function beginLogout() {
  return { type: LOGOUT_USER};
}

function logoutSuccess() {
  return { type: LOGOUT_SUCCESS_USER };
}

function logoutError() {
  return { type: LOGOUT_ERROR_USER };
}

export function toggleLoginMode() {
  return { type: TOGGLE_LOGIN_MODE };
}

export function manualLogin(data, locale) {
  return (dispatch) => {
    dispatch(beginLogin());

    return authService().login(data)
      .then((response) => {
          dispatch(loginSuccess('Welcome!'));
          dispatch(push('/'+ locale + '/dashboard'));
      })
      .catch((err) => {
        dispatch(loginError('Invalid credentials'));
      });
  };
}

export function signUp(data, locale) {
  return (dispatch) => {
    dispatch(beginSignUp());

    return authService().signUp(data)
      .then((response) => {
          dispatch(signUpSuccess('Success!'));
          dispatch(push('/' + locale));
      })
      .catch((err) => {
        dispatch(signUpError('Cannot register. Change credentials or try later'));
      });
  };
}

export function deleteAccount(){
  return (dispatch) => {
    return authService().deleteAccount().then(()=>{
      dispatch(logoutSuccess());
      dispatch(push('/login'));
    }).catch(()=>{
      dispatch(logoutSuccess());
      dispatch(push('/login'));
    });
  }
}

export function logOut(locale) {

  return (dispatch) => {
    dispatch(beginLogout());

    return authService().logOut()
      .then((response) => {
          dispatch(logoutSuccess());
           dispatch(push('/login'));
      })
      .catch((err) => {
        dispatch(logoutError());
      });
  };
}

const isLogin = (
  state = true,
  action
) => {
  switch (action.type) {
    case TOGGLE_LOGIN_MODE:
      return !state;
    default:
      return state;
  }
};

const message = (
  state = '',
  action
) => {
  switch (action.type) {
    case TOGGLE_LOGIN_MODE:
    case MANUAL_LOGIN_USER:
    case SIGNUP_USER:
    case LOGOUT_USER:
    case LOGIN_SUCCESS_USER:
    case SIGNUP_SUCCESS_USER:
      return '';
    case LOGIN_ERROR_USER:
    case SIGNUP_ERROR_USER:
      return action.message;
    default:
      return state;
  }
};

const isWaiting = (
  state = false,
  action
) => {
  switch (action.type) {
    case MANUAL_LOGIN_USER:
    case SIGNUP_USER:
    case LOGOUT_USER:
      return true;
    case LOGIN_SUCCESS_USER:
    case SIGNUP_SUCCESS_USER:
    case LOGOUT_SUCCESS_USER:
    case LOGIN_ERROR_USER:
    case SIGNUP_ERROR_USER:
    case LOGOUT_ERROR_USER:
      return false;
    default:
      return state;
  }
};

const authenticated = (
  state = false,
  action
) => {

  switch (action.type) {
    case LOGIN_SUCCESS_USER:
    case SIGNUP_SUCCESS_USER:
      return true;
    case LOGOUT_ERROR_USER:
    case LOGIN_ERROR_USER:
    case SIGNUP_ERROR_USER:
    case LOGOUT_SUCCESS_USER:
      return false;
    default:
      return state;
  }
};

const isAdmin = (state=false, action) =>{
  switch(action.type){
    case LOGOUT_ERROR_USER:
    case LOGIN_ERROR_USER:
    case SIGNUP_ERROR_USER:
    case LOGOUT_SUCCESS_USER:
      return false;    
    default:
      return state;
  }
}

const isShopify = (state=false, action) =>{
  switch(action.type){
    case LOGOUT_ERROR_USER:
    case LOGIN_ERROR_USER:
    case SIGNUP_ERROR_USER:
    case LOGOUT_SUCCESS_USER:
      return false;    
    default:
      return state;
  }
}


const email = (state='', action) =>{
  switch(action.type){
    case LOGOUT_ERROR_USER:
    case LOGIN_ERROR_USER:
    case SIGNUP_ERROR_USER:
    case LOGOUT_SUCCESS_USER:
      return '';    
    default:
      return state;
  }
}

const detectedLanguage = (state='en-US', action) =>{
  switch(action.type){
 
    default:
      return state;
  }
}

const location = (state={
  country: 'US',
  region: 'New York'
}, action) =>{
  switch(action.type){
 
    default:
      return state;
  }
}

const profile =(state={
  subscription: 'free'
}, action) =>{
  return state;
}

const emptyReducer = (state={}, action) =>{
  return state;
}

const address = emptyReducer;

const bank = emptyReducer;

const accounting = emptyReducer;

const website = emptyReducer;

const company =emptyReducer;

const phone = emptyReducer;

const registrationNumber = emptyReducer;

const taxId = emptyReducer;

const invoicePrefix = emptyReducer;
const currentInvoiceNumber = emptyReducer;
const decimalPlaces = emptyReducer;

const creditNotePrefix = emptyReducer;
const currentCreditNoteNumber = emptyReducer;


const currentInvoiceDate = emptyReducer;

const showVTA= emptyReducer;

const taxes = emptyReducer;

const shopify= emptyReducer;

const autoInvoicingMode = emptyReducer;

const notifications = emptyReducer;

const hasMultipleLocations = emptyReducer;
const match = emptyReducer;

const styles =  emptyReducer;

const autoStornoMode = emptyReducer;

const userReducer = combineReducers({
  email,
  isLogin,
  isWaiting,
  detectedLanguage,
  location,
  authenticated,
  message,
  isAdmin,
  isShopify,
  profile,
  shopify,
  address,
  match,
  website,
  bank,
  styles,
  company, 
  phone, 
  registrationNumber, 
  taxId,
  currentInvoiceNumber,
  decimalPlaces,
  currentCreditNoteNumber,
  creditNotePrefix,
  currentInvoiceDate,
  invoicePrefix,
  showVTA,
  taxes,
  accounting,
  autoInvoicingMode,
  notifications,
  autoStornoMode,
  hasMultipleLocations
});

export default userReducer;




// WEBPACK FOOTER //
// app/modules/user.js